import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6f44aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-accomplished" }
const _hoisted_2 = { class: "card-title d-flex justify-content-between mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Meta x Realizado Por Segmento", -1))
const _hoisted_4 = {
  key: 2,
  class: "flexLegend"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lengendChart carried" }, null, -1))
const _hoisted_6 = {
  key: 3,
  class: "flexLegend"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-baseline\" data-v-d6f44aca><div class=\"lengendChart budgeted\" data-v-d6f44aca></div><h6 data-v-d6f44aca>Orçado</h6></div><div class=\"d-flex align-items-baseline\" data-v-d6f44aca><div class=\"lengendChart billing\" data-v-d6f44aca></div><h6 data-v-d6f44aca>Em Faturamento</h6></div><div class=\"d-flex align-items-baseline\" data-v-d6f44aca><div class=\"lengendChart billed\" data-v-d6f44aca></div><h6 data-v-d6f44aca>Faturado</h6></div><div class=\"d-flex align-items-baseline\" data-v-d6f44aca><div class=\"lengendChart carried\" data-v-d6f44aca></div><h6 data-v-d6f44aca>Realizado</h6></div>", 4)
const _hoisted_11 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_NoAccess = _resolveComponent("NoAccess")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.access && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_NoAccess, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, _toDisplayString(_ctx.salesChannelName), 1)
    ]),
    (!_ctx.loading && _ctx.access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendChart, (legend) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex align-items-baseline",
              key: legend
            }, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createElementVNode("h6", null, _toDisplayString(legend), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VChart, {
      ref: "chart",
      class: _normalizeClass(["chart", {
        loadingClass: _ctx.loading,
      }]),
      option: _ctx.options,
      autoresize: ""
    }, null, 8, ["option", "class"]),
    (!_ctx.loading && _ctx.access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}